import React, { useState, useEffect, useMemo, useRef, useContext } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import PlusMinQty from "../../../utilities/PlusMinQty";
import { getBasketAction, updateBasketAction, UpdateBrokerActionPnl } from "../../../../redux/actions/brokerAction";
import { useDispatch, useSelector } from "react-redux";

import { Info, X } from "lucide-react";
import { fmtINR } from "../../../../util/helper";
import { Checkbox } from "antd";

const defSLTP = ["Comb Prem", "PNL", "Underlying"];

const OPERATOR_OPTIONS = [
  { value: 0, label: ">" },
  { value: 1, label: ">=" },
  { value: 2, label: "<" },
  { value: 3, label: "<=" },
];
const operatorLabel = (op) => OPERATOR_OPTIONS.find(o => o.value === op)?.label || ">";
const UNDERLYING_TYPES = [
  { value: 0, label: "Spot" },
  { value: 1, label: "Fut" },
  { value: 2, label: "SynFut" },
];

const parseNumeric = (str) => {
  if (!str) return 0;
  const cleanStr = str.replace(/[^\d.-]/g, '');
  return parseFloat(cleanStr) || 0;
};


const SLTPModal = ({ show, setShow, popUpData, istype, info, onSave, tickData }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [isError, seterror] = useState("");
  const [errorMessages, setErrorMessages] = useState({
    target: "",
    trailSL: "",
    profitLock: "",
    profitLockTrail: "",
    general: ""
  });
  const [netQuantity, setnetQuantity] = useState("");
  const [calcVal, setcalcVal] = useState(0);
  const [perLot, setPerLot] = useState(false);
  const [showScaleWarning, setShowScaleWarning] = useState(false);
  const [slValueType, setSlValueType] = useState(0);
  const [tpValueType, setTpValueType] = useState(0);
  const [trailValueType, setTrailValueType] = useState(2);
  const [slOperator, setSlOperator] = useState(2);
  const [tpOperator, setTpOperator] = useState(0);
  const [underlyingType, setUnderlyingType] = useState(0);

  useEffect(() => {
    if (popUpData) {
      const normalizedFormData = {
        ...popUpData.formData,
        stopLossAbsolute: popUpData.formData?.stopLossAbsolute === "" ? null : popUpData.formData?.stopLossAbsolute,
        takeProfitAbsolute: popUpData.formData?.takeProfitAbsolute === "" ? null : popUpData.formData?.takeProfitAbsolute,
        trailReferenceAbsolute: popUpData.formData?.trailReferenceAbsolute === "" ? null : popUpData.formData?.trailReferenceAbsolute,
        trailStepAbsolute: popUpData.formData?.trailStepAbsolute === "" ? null : popUpData.formData?.trailStepAbsolute,
      };
      setFormData(normalizedFormData);
      const basisInit = normalizedFormData?.sltpType;
      if (basisInit === "Underlying") {
        setSlValueType(0);
        setTpValueType(0);
        setTrailValueType(2);
        setSlOperator(popUpData.formData?.slOperator ?? 2);
        setTpOperator(popUpData.formData?.tpOperator ?? 0);
        setUnderlyingType(popUpData.formData?.underlyingType ?? 0);
      } else if (basisInit === "Comb Prem" && istype !== "broker") {
        setSlValueType(popUpData.formData?.slValueType ?? 0);
        setTpValueType(popUpData.formData?.tpValueType ?? 0);
        setTrailValueType(popUpData.formData?.trailValueType ?? 2);
      } else {
        setSlValueType(popUpData.formData?.slValueType ?? 0);
        setTpValueType(popUpData.formData?.tpValueType ?? 0);
        setTrailValueType(2);
      }
      setPerLot(!!popUpData.formData?.perLot);
    }
  }, [popUpData, istype]);

  useEffect(() => {
    if (popUpData && popUpData.row && popUpData.row.data) {
      var data = popUpData.row.data;
      var quantity = 0;
      var buyPremium = 0;
      var sellPremium = 0;
      for (let i = 0; i < data.length; i++) {
        const leg = data[i] || {};
        const netQty = parseFloat(leg.netQuantity || 0);
        const qty = Math.abs(netQty || parseFloat(leg.quantity || 0) || 0);
        const lotSize = parseFloat(leg.instrument?.lotSize || leg.lotSize || 1);
        const lots = lotSize > 0 ? (qty / lotSize) : 0;

        const token = leg.instrumentToken || leg.instrument?.instrumentToken;
        const ltp = parseFloat(tickData?.[token]?.lp || leg.ltp || 0);

        const sideInput = leg.transactionType || leg.side || (netQty < 0 ? "SELL" : netQty > 0 ? "BUY" : null);
        const side = sideInput ? String(sideInput).toUpperCase() : null;

        quantity += netQty;
        if (side) {
          if (perLot) {
            if (side === "BUY") buyPremium += ltp;
            else if (side === "SELL") sellPremium += ltp;
          } else if (lots > 0) {
            if (side === "BUY") buyPremium += ltp * lots;
            else if (side === "SELL") sellPremium += ltp * lots;
          }
        }
      }
      setcalcVal(buyPremium - sellPremium);
      setnetQuantity(quantity)
    }
  }, [popUpData, istype, perLot, tickData]);

  const isBasket = istype === "basket";
  const isBroker = istype === "broker";
  const isBasketOrBroker = isBasket || isBroker;
  const profitKeys = isBroker
    ? { profitAt: "profitLockAtPnl", profitSl: "profitLockSlPnl", trailRef: "profitLockTrailRefPnl", trailStep: "profitLockTrailStepPnl" }
    : { profitAt: "profitLockAt", profitSl: "profitLockSl", trailRef: "profitLockTrailRef", trailStep: "profitLockTrailStep" };


  const handlePerLotChange = (e) => {
    const checked = e.target.checked;
    setPerLot(checked);
    if (checked && (formData.stopLossAbsolute || formData.takeProfitAbsolute)) {
      setShowScaleWarning(true);
    } else if (!checked) {
      setShowScaleWarning(false);
    }
  };

  useEffect(() => {
    if (!formData.stopLossAbsolute && !formData.takeProfitAbsolute) {
      setShowScaleWarning(false);
    }
  }, [formData.stopLossAbsolute, formData.takeProfitAbsolute]);

  const handleFieldChange = (val, name, headersValue) => {
    if (name != "sltpType") {
      let value = {
        ...formData,
        [name]:
          name === "sltpType"
            ? val
            : (!val && val !== 0) ? null : parseFloat(val),
        name: headersValue.basketName,
      };

      if (name === "stopLossAbsolute" && (!val || val === null)) {
        value.trailReferenceAbsolute = null;
        value.trailStepAbsolute = null;
        setErrorMessages((prev) => ({ ...prev, trailSL: "" }));
      }

      if ((name === profitKeys.profitAt || name === profitKeys.profitSl) && (!val || val === null)) {
        value[profitKeys.trailRef] = null;
        value[profitKeys.trailStep] = null;
        setErrorMessages((prev) => ({ ...prev, profitLockTrail: "" }));
      }

      setFormData(value);

      if (name === "stopLossAbsolute") {
        const valToValidate = (!val && val !== 0) ? null : parseFloat(val);
        isValidsltp("sl", valToValidate, null);
      }

      if (name === "takeProfitAbsolute") {
        const valToValidate = (!val && val !== 0) ? null : parseFloat(val);
        isValidsltp("tp", valToValidate, null);
      }

      if (name === "trailReferenceAbsolute" || name === "trailStepAbsolute") {
        const newRef = name === "trailReferenceAbsolute" ? value.trailReferenceAbsolute : formData.trailReferenceAbsolute;
        const newStep = name === "trailStepAbsolute" ? value.trailStepAbsolute : formData.trailStepAbsolute;
        validateTrailSL(newRef, newStep);
      }

      // Validate profit lock when profit lock fields change
      if (name === profitKeys.profitAt || name === profitKeys.profitSl) {
        const newAt = name === profitKeys.profitAt ? value[profitKeys.profitAt] : formData[profitKeys.profitAt];
        const newSl = name === profitKeys.profitSl ? value[profitKeys.profitSl] : formData[profitKeys.profitSl];
        validateProfitLock(newAt, newSl);
      }

      // Validate profit lock trail when trail fields change
      if (name === profitKeys.trailRef || name === profitKeys.trailStep) {
        const newRef = name === profitKeys.trailRef ? value[profitKeys.trailRef] : formData[profitKeys.trailRef];
        const newStep = name === profitKeys.trailStep ? value[profitKeys.trailStep] : formData[profitKeys.trailStep];
        validateProfitLockTrail(newRef, newStep);
      }
    } else {

      if (popUpData.formData.sltpType === val) {
        setFormData({ ...popUpData.formData, sltpType: val })
      } else {
        setFormData({
          "sltpType": val,
          "stopLossAbsolute": null,
          "takeProfitAbsolute": null,
          "trailReferenceAbsolute": null,
          "trailStepAbsolute": null,
          "profitLockAt": null,
          "profitLockSl": null,
          "profitLockTrailRef": null,
          "profitLockTrailStep": null,
        })
        if (val === "Underlying") {
          setSlValueType(0);
          setTpValueType(0);
          setTrailValueType(2);
          setSlOperator(2);
          setTpOperator(0);
          setUnderlyingType(0);
        } else if (val === "Comb Prem") {
          setSlValueType(0);
          setTpValueType(0);
          setTrailValueType(2);
        } else {
          setSlValueType(0);
          setTpValueType(0);
          setTrailValueType(2);
        }
        seterror("");
        setErrorMessages({ stopLoss: "", target: "", trailSL: "", profitLock: "", profitLockTrail: "", general: "" });
        // Reset perLot when switching away from Premium
        if (val !== "Comb Prem") {
          setPerLot(false);
        }
      }

    }
  };

  const calculateActualPrice = (value, valueType, basePrice, isStopLoss = false) => {
    if (value === null || value === undefined || value === '' || value === 0) return null;
    const val = parseFloat(value);
    if (isNaN(val)) return null;

    const base = parseFloat(basePrice);
    if (isNaN(base)) return null;

    let result;
    switch (valueType) {
      case 0:
        result = val;
        break;
      case 1:
        if (formData.sltpType === "Comb Prem" || formData.sltpType === "PNL") {
          result = isStopLoss ? base - (Math.abs(base) * val / 100) : base + (Math.abs(base) * val / 100);
        } else {
          result = base + (base * val / 100);
        }
        break;
      case 2:
        if (formData.sltpType === "Comb Prem" || formData.sltpType === "PNL") {
          result = isStopLoss ? base - val : base + val;
        } else {
          result = isStopLoss ? -val : val;
        }
        break;
      default:
        result = val;
    }

    return result;
  };

  const getBasePrice = () => {

    const basisIsPNL = formData.sltpType === "PNL" || istype === "broker";

    if (istype === "broker") {
      const brokerPnlElement = document.getElementById("broker-pop-pnl");
      if (brokerPnlElement) {
        return parseNumeric(brokerPnlElement.innerText) || parseFloat(popUpData?.headersValue?.totalPNL || 0);
      }
    }

    if (istype === "basket") {
      const basketId = popUpData?.row?.basketId;
      if (basisIsPNL) {
        const pnlElement = document.getElementById(`${basketId}-pop-pnl`);
        if (pnlElement) {
          return parseNumeric(pnlElement.innerText) || parseFloat(popUpData?.headersValue?.totalPNL || 0);
        }
      } else {
        const combPremElement = document.getElementById(`${basketId}-comb-prm`);
        if (combPremElement) {
          return parseNumeric(combPremElement.innerText) || parseFloat(popUpData?.headersValue?.combPrem || 0);
        }
      }
    }

    // Fallback to initial values
    return basisIsPNL
      ? parseFloat(popUpData?.headersValue?.totalPNL || 0)
      : parseFloat(popUpData?.headersValue?.combPrem || 0);
  };


  const basePrice = getBasePrice();
  const slActualPrice = useMemo(() =>
    calculateActualPrice(formData.stopLossAbsolute, slValueType, basePrice, true),
    [formData.stopLossAbsolute, slValueType, basePrice, formData.sltpType, calcVal]
  );
  const tpActualPrice = useMemo(() =>
    calculateActualPrice(formData.takeProfitAbsolute, tpValueType, basePrice, false),
    [formData.takeProfitAbsolute, tpValueType, basePrice, formData.sltpType, calcVal]
  );
  const trailRefActualPrice = useMemo(() => {
    if (formData.trailReferenceAbsolute === null || formData.trailReferenceAbsolute === undefined || formData.trailReferenceAbsolute === '') {
      return null;
    }
    const val = parseFloat(formData.trailReferenceAbsolute);
    if (isNaN(val)) return null;

    const base = parseFloat(basePrice);
    if (isNaN(base)) return null;

    if (trailValueType === 1) {
      return base * val / 100;
    } else {
      return val;
    }
  }, [formData.trailReferenceAbsolute, trailValueType, basePrice]);

  const trailStepActualPrice = useMemo(() => {
    if (formData.trailStepAbsolute === null || formData.trailStepAbsolute === undefined || formData.trailStepAbsolute === '') {
      return null;
    }
    const val = parseFloat(formData.trailStepAbsolute);
    if (isNaN(val)) return null;

    const base = parseFloat(basePrice);
    if (isNaN(base)) return null;

    if (trailValueType === 1) {
      return base * val / 100;
    } else {
      return val;
    }
  }, [formData.trailStepAbsolute, trailValueType, basePrice]);


  const cycleWithin = (current, allowed) => {
    const idx = allowed.indexOf(current);
    const nextIdx = (idx + 1) % allowed.length;
    return allowed[nextIdx];
  };
  const renderTypeLabel = (vt) => (vt === 0 ? "₹" : vt === 1 ? "%" : "Pts");
  const renderTrailTypeLabel = (vt) => (vt === 1 ? "%" : "Pts");
  const renderPNLLabel = () => "₹₹";
  const renderPNLSLTPLabel = (vt) => (vt === 0 ? "₹₹" : "Pts");
  const onClickSlType = () => {
    const basis = formData?.sltpType;
    const newSlValueType = basis === "PNL" ?
      cycleWithin(slValueType, [0, 2]) :
      cycleWithin(slValueType, [0, 1, 2]);

    setSlValueType(newSlValueType);
    if (formData?.stopLossAbsolute !== null && formData?.stopLossAbsolute !== undefined && formData?.stopLossAbsolute !== '') {
      isValidsltp("sl", parseFloat(formData?.stopLossAbsolute), newSlValueType);
    }
  };

  const onClickTpType = () => {
    const basis = formData?.sltpType;
    const newTpValueType = basis === "PNL" ?
      cycleWithin(tpValueType, [0, 2]) :
      cycleWithin(tpValueType, [0, 1, 2]);

    setTpValueType(newTpValueType);
    if (formData?.takeProfitAbsolute !== null && formData?.takeProfitAbsolute !== undefined && formData?.takeProfitAbsolute !== '') {
      isValidsltp("tp", parseFloat(formData?.takeProfitAbsolute), newTpValueType);
    }
  };
  const onClickTrailType = () => {
    const basis = formData?.sltpType;
    if (basis === "PNL" || basis === "Underlying" || istype === "broker") {
      setTrailValueType(2);
      return;
    }
    setTrailValueType(prev => cycleWithin(prev, [2, 1]));
  };

  const isUnderlyingBasis = formData?.sltpType === "Underlying";

  const validateTrailSL = (ref, step) => {
    const refVal = ref !== null && ref !== undefined && ref !== '' ? parseFloat(ref) : null;
    const stepVal = step !== null && step !== undefined && step !== '' ? parseFloat(step) : null;

    if ((refVal !== null && stepVal === null) || (refVal === null && stepVal !== null)) {
      setErrorMessages((prev) => ({ ...prev, trailSL: "Both fields are required" }));
      return false;
    }

    if (refVal !== null && stepVal !== null) {
      if (refVal < 0 || stepVal < 0) {
        setErrorMessages((prev) => ({ ...prev, trailSL: "Trail SL Reference and Step must be non-negative" }));
        return false;
      }
    }

    setErrorMessages((prev) => ({ ...prev, trailSL: "" }));
    return true;
  };

  const validateProfitLock = (profitLockAt, profitLockSl) => {
    const atVal = profitLockAt !== null && profitLockAt !== undefined && profitLockAt !== '' ? parseFloat(profitLockAt) : null;
    const slVal = profitLockSl !== null && profitLockSl !== undefined && profitLockSl !== '' ? parseFloat(profitLockSl) : null;

    if (atVal !== null && slVal === null) {
      setErrorMessages((prev) => ({ ...prev, profitLock: "Both fields are required" }));
      return false;
    }

    setErrorMessages((prev) => ({ ...prev, profitLock: "" }));
    return true;
  };

  const validateProfitLockTrail = (ref, step) => {
    const refVal = ref !== null && ref !== undefined && ref !== '' ? parseFloat(ref) : null;
    const stepVal = step !== null && step !== undefined && step !== '' ? parseFloat(step) : null;

    if ((refVal !== null && stepVal === null) || (refVal === null && stepVal !== null)) {
      setErrorMessages((prev) => ({ ...prev, profitLockTrail: "Both fields are required" }));
      return false;
    }

    if (refVal !== null && stepVal !== null) {
      if (refVal < 0 || stepVal < 0) {
        setErrorMessages((prev) => ({ ...prev, profitLockTrail: "Profit Trail values cannot be negative" }));
        return false;
      }
    }

    setErrorMessages((prev) => ({ ...prev, profitLockTrail: "" }));
    return true;
  };

  const isValidsltp = (type, val, overrideType = null) => {
    const valueType = overrideType ?? (type === "sl" ? slValueType : tpValueType);
    const setMsg = (ok, customMsg = null) => {
      if (type === "sl") {
        const msg = customMsg || ((formData.sltpType === "PNL" || istype === "broker") ? "Stop Loss should be below current PNL" : "Stop Loss should be below combined premium");
        setErrorMessages((prev) => ({ ...prev, stopLoss: ok ? "" : msg }));
      } else {
        const msg = customMsg || ((formData.sltpType === "PNL" || istype === "broker") ? "Target should be above current PNL" : "Target should be above combined premium");
        setErrorMessages((prev) => ({ ...prev, target: ok ? "" : msg }));
      }
    };

    if (val === null || val === undefined || val === '' || val === 0) {
      setMsg(true);
      seterror("");
      return true;
    }

    const parsedVal = parseFloat(val);
    if (Number.isNaN(parsedVal)) {
      setMsg(true);
      seterror("");
      return true;
    }

    // Underlying basis: user picks arbitrary price levels, no current-value validation needed
    if (formData.sltpType === "Underlying") {
      if (parsedVal <= 0) {
        setMsg(false, type === "sl" ? "Stop Loss price must be positive" : "Target price must be positive");
        seterror("");
        return false;
      }
      setMsg(true);
      seterror("");
      return true;
    }

    const currentBasePrice = getBasePrice();
    const actualPrice = type === "sl"
      ? calculateActualPrice(parsedVal, valueType, currentBasePrice, true)
      : calculateActualPrice(parsedVal, valueType, currentBasePrice, false);

    if (actualPrice === null) {
      setMsg(true);
      seterror("");
      return true;
    }

    const basisIsPNL = formData.sltpType === "PNL" || istype === "broker";

    if (basisIsPNL && istype === "basket") {
      if (valueType === 2 && parsedVal < 0) {
        setMsg(false, type === "sl" ? "Stop Loss cannot be negative" : "Target cannot be negative");
        seterror("");
        return false;
      }
    }

    if (istype === "basket") {
      const basisIsPNL = formData.sltpType === "PNL";
      const ref = currentBasePrice;

      if (Number.isNaN(ref)) {
        setMsg(true);
        seterror("");
        return true;
      }

      if (basisIsPNL || formData.sltpType === "Comb Prem") {
        if (type === "sl") {
          const ok = actualPrice < ref;
          seterror(ok ? "" : type);
          setMsg(ok);
          return ok;
        } else {
          const ok = actualPrice > ref;
          seterror(ok ? "" : type);
          setMsg(ok);
          return ok;
        }
      }
    }

    if (istype === "broker") {
      const brokerPnl = currentBasePrice;
      if (Number.isNaN(brokerPnl)) {
        setMsg(true);
        seterror("");
        return true;
      }
      if (type === "sl") {
        const ok = actualPrice < brokerPnl;
        seterror(ok ? "" : type);
        setMsg(ok);
        return ok;
      } else {
        const ok = actualPrice > brokerPnl;
        seterror(ok ? "" : type);
        setMsg(ok);
        return ok;
      }
    }


    return true;
  }

  useEffect(() => {
    if (!show || !popUpData || !formData || Object.keys(formData).length === 0) return;

    if (isBasketOrBroker && formData.stopLossAbsolute !== null && formData.stopLossAbsolute !== undefined && formData.stopLossAbsolute !== '') {
      isValidsltp("sl", parseFloat(formData.stopLossAbsolute));
    }

    if (isBasketOrBroker && formData.takeProfitAbsolute !== null && formData.takeProfitAbsolute !== undefined && formData.takeProfitAbsolute !== '') {
      isValidsltp("tp", parseFloat(formData.takeProfitAbsolute));
    }

    if (isBasketOrBroker) {
      validateTrailSL(formData.trailReferenceAbsolute, formData.trailStepAbsolute);
    }

    if (isBasketOrBroker) {
      validateProfitLock(formData[profitKeys.profitAt], formData[profitKeys.profitSl]);
    }

    if (isBasketOrBroker) {
      validateProfitLockTrail(formData[profitKeys.trailRef], formData[profitKeys.trailStep]);
    }
  }, []);

  // Helper: check if all basket positions share one underlying
  const getBasketUnderlyings = () => {
    const positions = popUpData?.row?.data || [];
    const underlyings = new Set();
    positions.forEach(p => {
      if (p.instrument?.name) underlyings.add(p.instrument.name);
    });
    return underlyings;
  };

  const clickActionSave = () => {
    if (isBasketOrBroker) {
      // Single-underlying check for Underlying basis
      if (formData.sltpType === "Underlying" && istype === "basket") {
        const underlyings = getBasketUnderlyings();
        if (underlyings.size > 1) {
          seterror("underlying");
          setErrorMessages(prev => ({ ...prev, general: "Underlying-based RMS requires all positions to share the same underlying (" + [...underlyings].join(", ") + " found)" }));
          return false;
        }
      }

      if (!isValidsltp("sl", parseFloat(formData.stopLossAbsolute))) {
        return false
      }
      if (!isValidsltp("tp", parseFloat(formData.takeProfitAbsolute))) {
        return false
      }

      // Trail/profit lock not applicable for Underlying
      if (!isUnderlyingBasis) {
        if (!validateTrailSL(formData.trailReferenceAbsolute, formData.trailStepAbsolute)) {
          return false;
        }
        if (!validateProfitLock(formData[profitKeys.profitAt], formData[profitKeys.profitSl])) {
          return false;
        }
        if (!validateProfitLockTrail(formData[profitKeys.trailRef], formData[profitKeys.trailStep])) {
          return false;
        }
      }
    }

    var value = formData;

    updateBasketFun(value, popUpData.row.basketId);
    if (onSave) {
      onSave(value);
    }
    return true;
  };

  const updateBasketFun = async (value, basketId) => {
    const basis = formData?.sltpType;
    const norm = (n) => {
      if (n === 0) return 0;
      if (n === undefined || n === null || n === "") return null;
      const p = parseFloat(n);
      return Number.isNaN(p) ? null : p;
    };
    const isTrailNull = (ref, step) => {
      const refVal = norm(ref);
      const stepVal = norm(step);
      return refVal === null && stepVal === null;
    };
    const isValueNull = (val) => norm(val) === null;

    // Underlying basis payload
    if (basis === "Underlying") {
      const payload = {
        rms: {
          basis: 2,
          underlyingType: underlyingType,
          stopLossInput: isValueNull(value.stopLossAbsolute) ? null : {
            valueType: 0,
            value: norm(value.stopLossAbsolute)
          },
          stopLossOperator: slOperator,
          takeProfitInput: isValueNull(value.takeProfitAbsolute) ? null : {
            valueType: 0,
            value: norm(value.takeProfitAbsolute)
          },
          takeProfitOperator: tpOperator,
        }
      };
      if (istype === "broker") {
        await dispatch(UpdateBrokerActionPnl(info?.broker?.id, payload));
      } else if (istype === "basket") {
        await dispatch(updateBasketAction(basketId, payload));
      }
      return;
    }

    if (istype === "broker") {
      const payload = {
        rms: {
          basis: basis === "Comb Prem" ? 1 : 0,
          takeProfitInput: isValueNull(value.takeProfitAbsolute) ? null : {
            valueType: tpValueType ?? 0,
            value: norm(value.takeProfitAbsolute)
          },
          stopLossInput: isValueNull(value.stopLossAbsolute) ? null : {
            valueType: slValueType ?? 0,
            value: norm(value.stopLossAbsolute)
          },
          trailSL: isTrailNull(value.trailReferenceAbsolute, value.trailStepAbsolute) ? null : {
            valueType: (basis === "PNL" || istype === "broker") ? 2 : (trailValueType === 1 ? 1 : 2),
            reference: norm(value.trailReferenceAbsolute),
            step: norm(value.trailStepAbsolute)
          },
          profitLockAt: norm(value[profitKeys.profitAt]),
          profitLockSl: norm(value[profitKeys.profitSl]),
          profitLockTrail: isTrailNull(value[profitKeys.trailRef], value[profitKeys.trailStep]) ? null : {
            valueType: 2,
            reference: norm(value[profitKeys.trailRef]),
            step: norm(value[profitKeys.trailStep])
          },
          perLot: basis === "Comb Prem" ? perLot : false
        }
      };
      await dispatch(UpdateBrokerActionPnl(info?.broker?.id, payload));
      return;
    } else if (istype === "basket") {
      const rmsPayload = {
        basis: basis === "Comb Prem" ? 1 : 0,
        takeProfitInput: isValueNull(value.takeProfitAbsolute) ? null : {
          valueType: tpValueType ?? 0,
          value: norm(value.takeProfitAbsolute)
        },
        stopLossInput: isValueNull(value.stopLossAbsolute) ? null : {
          valueType: slValueType ?? 0,
          value: norm(value.stopLossAbsolute)
        },
        trailSL: isTrailNull(value.trailReferenceAbsolute, value.trailStepAbsolute) ? null : {
          valueType: (trailValueType === 1 ? 1 : 2),
          reference: norm(value.trailReferenceAbsolute),
          step: norm(value.trailStepAbsolute)
        },
        profitLockAt: norm(value[profitKeys.profitAt]),
        profitLockSl: norm(value[profitKeys.profitSl]),
        profitLockTrail: isTrailNull(value[profitKeys.trailRef], value[profitKeys.trailStep]) ? null : {
          valueType: 2,
          reference: norm(value[profitKeys.trailRef]),
          step: norm(value[profitKeys.trailStep])
        },
        perLot: basis === "Comb Prem" ? perLot : false
      };
      if (basis === "Comb Prem") {
        rmsPayload.perLot = perLot;
      }
      const payload = { rms: rmsPayload };
      await dispatch(updateBasketAction(basketId, payload));
      if (onSave) {
        onSave({ perLot: perLot });
      }
    }
  };

  const clearfiled = (name) => {
    let updatedFormData = {
      ...formData,
      [name]: null
    };

    if (name === "stopLossAbsolute") {
      updatedFormData.trailReferenceAbsolute = null;
      updatedFormData.trailStepAbsolute = null;
      setErrorMessages((prev) => ({ ...prev, stopLoss: "", trailSL: "" }));
      seterror("");
    }
    else if (name === profitKeys.profitAt || name === profitKeys.profitSl) {
      updatedFormData[profitKeys.trailRef] = null;
      updatedFormData[profitKeys.trailStep] = null;
      setErrorMessages((prev) => ({ ...prev, profitLockTrail: "" }));
      if (name === "takeProfitAbsolute") {
        setErrorMessages((prev) => ({ ...prev, target: "" }));
        seterror("");
      }
    }
    else if (name === "takeProfitAbsolute") {
      setErrorMessages((prev) => ({ ...prev, target: "" }));
      seterror("");
    }
    // Validate trail SL when one field is cleared
    else if (name === "trailReferenceAbsolute") {
      const otherValue = updatedFormData.trailStepAbsolute;
      if (otherValue !== null && otherValue !== undefined && otherValue !== '') {
        validateTrailSL(null, otherValue);
      } else {
        setErrorMessages(prev => ({ ...prev, trailSL: "" }));
      }
    }
    else if (name === "trailStepAbsolute") {
      const otherValue = updatedFormData.trailReferenceAbsolute;
      if (otherValue !== null && otherValue !== undefined && otherValue !== '') {
        validateTrailSL(otherValue, null);
      } else {
        setErrorMessages(prev => ({ ...prev, trailSL: "" }));
      }
    }
    // Validate profit lock trail when one field is cleared
    else if (name === profitKeys.trailRef) {
      const otherValue = formData[profitKeys.trailStep];
      if (otherValue !== null && otherValue !== undefined && otherValue !== '') {
        validateProfitLockTrail(null, otherValue);
      } else {
        setErrorMessages(prev => ({ ...prev, profitLockTrail: "" }));
      }
    }
    else if (name === profitKeys.trailStep) {
      const otherValue = formData[profitKeys.trailRef];
      if (otherValue !== null && otherValue !== undefined && otherValue !== '') {
        validateProfitLockTrail(otherValue, null);
      } else {
        setErrorMessages(prev => ({ ...prev, profitLockTrail: "" }));
      }
    }

    setFormData(updatedFormData);
  }

  const handleReset = () => {
    if (popUpData) {
      const resetFormData = {
        ...popUpData.formData,
        stopLossAbsolute: null,
        takeProfitAbsolute: null,
        trailReferenceAbsolute: null,
        trailStepAbsolute: null,
        profitLockAt: null,
        profitLockSl: null,
        profitLockTrailRef: null,
        profitLockTrailStep: null,
      };
      setFormData(resetFormData);
      setErrorMessages({
        stopLoss: "",
        target: "",
        trailSL: "",
        profitLock: "",
        profitLockTrail: "",
        general: ""
      });
      const basisInit = resetFormData?.sltpType || popUpData.formData?.sltpType;
      if (basisInit === "Comb Prem" && istype !== "broker") {
        setSlValueType(2);
        setTpValueType(2);
        setTrailValueType(2);
      } else {
        setSlValueType(popUpData.formData?.slValueType ?? 0);
        setTpValueType(popUpData.formData?.tpValueType ?? 0);
        setTrailValueType(2);
      }
      seterror("");
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="fixed-modal-sltp "
      >
        <Modal.Header style={{ position: 'relative' }}>
          <Modal.Title
            className="modal-title-size"
            id="contained-modal-title-vcenter"
          >
            {" "}
            {istype === "basket" ? "Strategy" + (calcVal > 0 ? '(D)' : calcVal < 0 ? '(C)' : '') + ": " + popUpData?.headersValue?.basketName + ' - Risk Settings' :
              istype === "profileLock" ? "Strategy" + (calcVal > 0 ? '(D)' : calcVal < 0 ? '(C)' : '') + ": " + popUpData?.headersValue?.basketName + ' -Profit Locking & Tralling Setting' :
                "Account Level(" + info.brokerID + ") Risk Settings"}{" "}
          </Modal.Title>
          <button
            type="button"
            className="modal-close-button"
            onClick={() => setShow(false)}
            aria-label="Close"
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-sltp">

            <div style={{ justifyContent: "space-between" }} className="sltp-div modal-input ">
              {(istype === "basket") &&
                <Form.Group className="form-group">
                  <label className="form-label">SL/TP Basis</label>
                  <Form.Select
                    aria-label="Default select example"
                    name="sltpType"
                    value={formData.sltpType}
                    onChange={(e) =>
                      handleFieldChange(e.target.value, "sltpType", popUpData?.headersValue)
                    }
                  >
                    {defSLTP.map((data, index) => {
                      return (
                        <option value={data} key={index}>
                          {data}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              }
              {(istype === "basket") && formData.sltpType === "Comb Prem" && (
                <Checkbox
                  id="perLot-position-basket"
                  checked={perLot}
                  onChange={handlePerLotChange}
                  style={{ fontSize: '11px', marginLeft: '8px', whiteSpace: 'nowrap', width: '100px' }}
                >
                  1 Lot RMS
                </Checkbox>
              )}
              <div className="pnl-com-p">
                {istype === "broker" ?
                  <p className="m-0">PNL: <span id={"broker-pop-pnl"} className={popUpData?.headersValue?.totalPNL === 0 ? "" : popUpData?.headersValue?.totalPNL > 0 ? "text-success" : "text-danger"}>{fmtINR(popUpData?.headersValue?.totalPNL)}</span></p>
                  : (istype === "basket") && formData.sltpType === "Underlying" ?
                    <p className="m-0" style={{ fontSize: '11px', color: '#888' }}>Underlying (Spot)</p>
                    : (istype === "basket") && formData.sltpType === "PNL" ?
                      <p className="m-0">PNL: <span id={popUpData?.row?.basketId + "-pop-pnl"} className={popUpData?.headersValue?.totalPNL === 0 ? "" : popUpData?.headersValue?.totalPNL > 0 ? "text-success" : "text-danger"}>{fmtINR(popUpData?.headersValue?.totalPNL)}</span></p>
                      : (istype === "basket") && formData.sltpType === "Comb Prem" ?
                        <p className="m-0">Comb Prem: <span id={popUpData?.row?.basketId + "-comb-prm"} style={{ color: "inherit !important" }}>{fmtINR(calcVal)}</span></p>
                        : <p className="m-0">PNL: <span id={popUpData?.row?.basketId + "-pop-pnl"} className={popUpData?.headersValue?.totalPNL === 0 ? "" : popUpData?.headersValue?.totalPNL > 0 ? "text-success" : "text-danger"}>{fmtINR(popUpData?.headersValue?.totalPNL)}</span></p>
                }
              </div>
            </div>

            {showScaleWarning && (
              <div className="info-note mb-2" style={{ fontSize: '10px', padding: '8px 10px' }}>
                <Info size={12} style={{ color: '#faad14', marginRight: '4px' }} />
                <span>Scale changed! Please re-verify Absolute SL/TP (Values are now Per Lot).</span>
              </div>
            )}
            {/* Underlying Type selector */}
            {isUnderlyingBasis && istype === "basket" && (
              <div className="sltp-div modal-input" style={{ marginTop: '8px' }}>
                <Form.Group className="form-group">
                  <label className="form-label">Underlying Type</label>
                  <Form.Select
                    value={underlyingType}
                    onChange={(e) => setUnderlyingType(parseInt(e.target.value))}
                  >
                    {UNDERLYING_TYPES.map((ut) => (
                      <option value={ut.value} key={ut.value}>
                        {ut.label}{ut.disabled ? " (coming soon)" : ""}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            )}


            {(istype === "basket" || istype === "broker") &&
              <div className={isUnderlyingBasis ? "sltp-div flex-column gap-3 w-100" : "sltp-div"}>
                <div className={isUnderlyingBasis ? "w-100" : "sltp-col-left"}>
                  <Form.Label className="sltp-label-above" style={{ fontWeight: 600 }}>
                    Stop Loss
                    {!isUnderlyingBasis && slActualPrice !== null && (slValueType === 1 || slValueType === 2) && (
                      <span style={{ marginLeft: '10px', fontSize: '11px', color: '#666', fontWeight: 'normal' }}>
                        ({fmtINR(slActualPrice)})
                      </span>
                    )}
                  </Form.Label>
                  <div className="sltp-input-row">
                    {isUnderlyingBasis && (
                      <Form.Select
                        style={{ width: '60px', minWidth: '60px', padding: '2px 4px', fontSize: '12px', marginRight: '4px' }}
                        value={slOperator}
                        onChange={(e) => setSlOperator(parseInt(e.target.value))}
                      >
                        {OPERATOR_OPTIONS.map(op => (
                          <option value={op.value} key={op.value}>{op.label}</option>
                        ))}
                      </Form.Select>
                    )}
                    <div className={errorMessages.stopLoss ? "error-border" : ""}>
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(qty, "stopLossAbsolute", popUpData.headersValue);
                        }}
                        filterValue={formData.stopLossAbsolute}
                        name={"stopLossAbsolute"}
                        min={null}
                        step={null}
                        max={null}
                        title={""}
                        formatINR={true}
                      />
                    </div>
                    {isUnderlyingBasis ? (
                      <div className="pts-class">₹</div>
                    ) : formData?.sltpType === "PNL" || istype === "broker" ? (
                      <div className="pts-class" onClick={onClickSlType}>{renderPNLSLTPLabel(slValueType)}</div>
                    ) : (
                      <div className="pts-class" onClick={onClickSlType}>{renderTypeLabel(slValueType)}</div>
                    )}
                    <X
                      size={16}
                      onClick={() => clearfiled("stopLossAbsolute")}
                      className="sltp-delete-icon sltp-delete-icon-enabled"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {errorMessages.stopLoss && (
                    <div className="text-danger mt-1" style={{ fontSize: '10px' }}>
                      {errorMessages.stopLoss}
                    </div>
                  )}
                </div>
                <div className={isUnderlyingBasis ? "w-100" : "sltp-col-right"}>
                  <Form.Label className="sltp-label-above" style={{ fontWeight: 600 }}>
                    Target
                    {!isUnderlyingBasis && tpActualPrice !== null && (tpValueType === 1 || tpValueType === 2) && (
                      <span style={{ marginLeft: '10px', fontSize: '11px', color: '#666', fontWeight: 'normal' }}>
                        ({fmtINR(tpActualPrice)})
                      </span>
                    )}
                  </Form.Label>
                  <div className="sltp-input-row">
                    {isUnderlyingBasis && (
                      <Form.Select
                        style={{ width: '60px', minWidth: '60px', padding: '2px 4px', fontSize: '12px', marginRight: '4px' }}
                        value={tpOperator}
                        onChange={(e) => setTpOperator(parseInt(e.target.value))}
                      >
                        {OPERATOR_OPTIONS.map(op => (
                          <option value={op.value} key={op.value}>{op.label}</option>
                        ))}
                      </Form.Select>
                    )}
                    <div className={errorMessages.target ? "error-border" : ""}>
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(qty, "takeProfitAbsolute", popUpData.headersValue);
                        }}
                        filterValue={formData.takeProfitAbsolute}
                        name={"takeProfitAbsolute"}
                        min={null}
                        step={null}
                        max={null}
                        title={""}
                        formatINR={true}
                      />
                    </div>
                    {isUnderlyingBasis ? (
                      <div className="pts-class">₹</div>
                    ) : formData?.sltpType === "PNL" || istype === "broker" ? (
                      <div className="pts-class" onClick={onClickTpType}>{renderPNLSLTPLabel(tpValueType)}</div>
                    ) : (
                      <div className="pts-class" onClick={onClickTpType}>{renderTypeLabel(tpValueType)}</div>
                    )}
                    <X
                      size={16}
                      onClick={() => clearfiled("takeProfitAbsolute")}
                      className="sltp-delete-icon sltp-delete-icon-enabled"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {errorMessages.target && (
                    <div className="text-danger mt-1" style={{ fontSize: '10px' }}>
                      {errorMessages.target}
                    </div>
                  )}
                </div>
              </div>
            }
            {(istype === "basket" || istype === "broker") && !isUnderlyingBasis &&
              <div className="sltp-div-profile">
                {/* Stoploss Trailing */}
                <p className="sltp-trail-header">Stoploss Trailing</p>
                <div className="sltp-div">
                  <div className="sltp-col-left">
                    <Form.Label className="sltp-label-above">
                      For every X move
                      {trailRefActualPrice !== null && typeof trailRefActualPrice === 'number' && (
                        <span style={{ marginLeft: '10px', fontSize: '11px', color: '#666', fontWeight: 'normal' }}>
                          (₹{trailRefActualPrice.toFixed(2)})
                        </span>
                      )}
                    </Form.Label>
                    <div className="sltp-input-row">
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(
                            qty,
                            "trailReferenceAbsolute",
                            popUpData.headersValue
                          );
                        }}
                        filterValue={formData.trailReferenceAbsolute ?? null}
                        name={"trailReferenceAbsolute"}
                        min={0.05}
                        step={0.05}
                        formatINR={true}
                        disabled={formData.stopLossAbsolute === null || formData.stopLossAbsolute === undefined}
                      />
                      {(formData?.sltpType === "PNL" || istype === "broker") ? (
                        <div className="pts-class">{renderPNLLabel()}</div>
                      ) : (
                        <div className="pts-class" onClick={onClickTrailType}>{renderTrailTypeLabel(trailValueType)}</div>
                      )}
                      <X
                        size={16}
                        onClick={() => clearfiled("trailReferenceAbsolute")}
                        className={`sltp-delete-icon ${(formData.stopLossAbsolute === null || formData.stopLossAbsolute === undefined) ? 'sltp-delete-icon-disabled' : 'sltp-delete-icon-enabled'}`}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                  <div className="sltp-col-right">
                    <Form.Label className="sltp-label-above">
                      Trail SL by Y
                      {trailStepActualPrice !== null && typeof trailStepActualPrice === 'number' && (
                        <span style={{ marginLeft: '10px', fontSize: '11px', color: '#666', fontWeight: 'normal' }}>
                          ({fmtINR(trailStepActualPrice.toFixed(2))})
                        </span>
                      )}
                    </Form.Label>
                    <div className="sltp-input-row">
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(qty, "trailStepAbsolute", popUpData.headersValue);
                        }}
                        filterValue={formData.trailStepAbsolute ?? null}
                        name={"trailStepAbsolute"}
                        min={0.05}
                        step={0.05}
                        formatINR={true}
                        disabled={formData.stopLossAbsolute === null || formData.stopLossAbsolute === undefined}
                      />
                      {(formData?.sltpType === "PNL" || istype === "broker") ? (
                        <div className="pts-class">{renderPNLLabel()}</div>
                      ) : (
                        <div className="pts-class" onClick={onClickTrailType}>{renderTrailTypeLabel(trailValueType)}</div>
                      )}
                      <X
                        size={16}
                        onClick={() => clearfiled("trailStepAbsolute")}
                        className={`sltp-delete-icon ${(formData.stopLossAbsolute === null || formData.stopLossAbsolute === undefined) ? 'sltp-delete-icon-disabled' : 'sltp-delete-icon-enabled'}`}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                </div>
                {errorMessages.trailSL && (
                  <div className="text-danger mt-1 mb-2" style={{ fontSize: '10px', textAlign: 'center' }}>
                    {errorMessages.trailSL}
                  </div>
                )}
                <p className="sltp-trail-header">Profit Locking</p>
                <div className="sltp-div">
                  <div className="sltp-col-left">
                    <Form.Label className="sltp-label-above">When profit reaches</Form.Label>
                    <div className="sltp-input-row">
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(qty, profitKeys.profitAt, popUpData.headersValue);
                        }}
                        filterValue={formData[profitKeys.profitAt] ?? null}
                        name={profitKeys.profitAt}
                        min={null}
                        step={null}
                        max={null}
                        title={""}
                        formatINR={true}
                      />
                      <div className="pts-class">{renderPNLLabel()}</div>
                      <X
                        size={16}
                        onClick={() => clearfiled(profitKeys.profitAt)}
                        className="sltp-delete-icon sltp-delete-icon-enabled"
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                  <div className="sltp-col-right">
                    <Form.Label className="sltp-label-above">Lock minimum profit at</Form.Label>
                    <div className="sltp-input-row">
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          handleFieldChange(qty, profitKeys.profitSl, popUpData.headersValue);
                        }}
                        filterValue={formData[profitKeys.profitSl] ?? null}
                        name={profitKeys.profitSl}
                        min={null}
                        step={null}
                        max={null}
                        title={""}
                        formatINR={true}
                      />
                      <div className="pts-class">{renderPNLLabel()}</div>
                      <X
                        size={16}
                        onClick={() => clearfiled(profitKeys.profitSl)}
                        className="sltp-delete-icon sltp-delete-icon-enabled"
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                </div>
                {errorMessages.profitLock && (
                  <div className="text-danger mt-1 mb-2" style={{ fontSize: '10px', textAlign: 'center' }}>
                    {errorMessages.profitLock}
                  </div>
                )}
                {/* Profit Trailing */}
                {(istype === "basket" || istype === "broker") &&
                  <>
                    <p className="sltp-trail-header">Profit Trailing</p>
                    <div className="sltp-div">
                      <div className="sltp-col-left">
                        <Form.Label className="sltp-label-above">If profit increases by X</Form.Label>
                        <div className="sltp-input-row">
                          <PlusMinQty
                            qtyClick={(qty, value) => {
                              handleFieldChange(qty, profitKeys.trailRef, popUpData.headersValue);
                            }}
                            filterValue={formData[profitKeys.trailRef] ?? null}
                            name={profitKeys.trailRef}
                            min={0.05}
                            step={0.05}
                            max={null}
                            title={""}
                            formatINR={true}
                            disabled={formData[profitKeys.profitAt] === null || formData[profitKeys.profitSl] === null}
                          />
                          <div className="pts-class">{renderPNLLabel()}</div>
                          <X
                            size={16}
                            onClick={() => clearfiled(profitKeys.trailRef)}
                            className={`sltp-delete-icon ${(formData[profitKeys.profitAt] === null || formData[profitKeys.profitSl] === null) ? 'sltp-delete-icon-disabled' : 'sltp-delete-icon-enabled'}`}
                            style={{ cursor: 'pointer' }}
                          />
                        </div>
                      </div>
                      <div className="sltp-col-right">
                        <Form.Label className="sltp-label-above">Trail Profit by Y</Form.Label>
                        <div className="sltp-input-row">
                          <PlusMinQty
                            qtyClick={(qty, value) => {
                              handleFieldChange(qty, profitKeys.trailStep, popUpData.headersValue);
                            }}
                            filterValue={formData[profitKeys.trailStep] ?? null}
                            name={profitKeys.trailStep}
                            min={0.05}
                            step={0.05}
                            max={null}
                            title={""}
                            formatINR={true}
                            disabled={formData[profitKeys.profitAt] === null || formData[profitKeys.profitSl] === null}
                          />
                          <div className="pts-class">{renderPNLLabel()}</div>
                          <X
                            size={16}
                            onClick={() => clearfiled(profitKeys.trailStep)}
                            className={`sltp-delete-icon ${(formData[profitKeys.profitAt] === null || formData[profitKeys.profitSl] === null) ? 'sltp-delete-icon-disabled' : 'sltp-delete-icon-enabled'}`}
                            style={{ cursor: 'pointer' }}
                          />
                        </div>
                      </div>
                    </div>
                    {errorMessages.profitLockTrail && (
                      <div className="text-danger mt-1 mb-2" style={{ fontSize: '10px', textAlign: 'center' }}>
                        {errorMessages.profitLockTrail}
                      </div>
                    )}
                  </>
                }
              </div>
            }
          </div>

          {/* Summary Section */}
          <div className="sltp-summary-section" >
            <div className="sltp-summary-title">
              Summary
            </div>
            <div className="sltp-summary-body">
              {(() => {
                const summaryLines = [];

                // Underlying basis summary
                if (formData?.sltpType === "Underlying") {
                  const utLabel = UNDERLYING_TYPES.find(u => u.value === underlyingType)?.label || "Spot";
                  if (formData.stopLossAbsolute !== null && formData.stopLossAbsolute !== undefined && formData.stopLossAbsolute !== '') {
                    summaryLines.push(`SL fires when underlying ${utLabel} LTP ${operatorLabel(slOperator)} ₹${parseFloat(formData.stopLossAbsolute).toFixed(2)}`);
                  }
                  if (formData.takeProfitAbsolute !== null && formData.takeProfitAbsolute !== undefined && formData.takeProfitAbsolute !== '') {
                    summaryLines.push(`TP fires when underlying ${utLabel} LTP ${operatorLabel(tpOperator)} ₹${parseFloat(formData.takeProfitAbsolute).toFixed(2)}`);
                  }
                  if (summaryLines.length === 0) {
                    return <div style={{ color: '#6c757d', fontStyle: 'italic' }}>No risk settings configured</div>;
                  }
                  return summaryLines.map((line, index) => (
                    <div key={index} style={{ marginBottom: index < summaryLines.length - 1 ? '8px' : '0' }}>
                      {line}
                    </div>
                  ));
                }

                const basisLabel = formData?.sltpType === "PNL" || istype === "broker" ? "PnL" : "combined premium";

                // Stop Loss
                if (formData.stopLossAbsolute !== null && formData.stopLossAbsolute !== undefined && formData.stopLossAbsolute !== '') {
                  const slValue = parseFloat(formData.stopLossAbsolute);
                  let slText = '';
                  if (formData?.sltpType === "PNL" || istype === "broker") {
                    if (slValueType === 0) {
                      slText = `₹${Math.abs(slValue).toFixed(2)}`;
                    } else {
                      // For Pts, show actual price
                      if (slActualPrice !== null) {
                        slText = `₹${Math.abs(slActualPrice).toFixed(2)}`;
                      } else {
                        slText = `${Math.abs(slValue).toFixed(2)} pts`;
                      }
                    }
                    summaryLines.push(`If ${basisLabel} falls to ${slText}, the strategy will exit.`);
                  } else {
                    let slDisplay = '';
                    if (slValueType === 0) {
                      slDisplay = `₹${slValue.toFixed(2)}`;
                    } else if (slValueType === 1 || slValueType === 2) {
                      // For % and Pts, show actual price
                      if (slActualPrice !== null) {
                        slDisplay = `₹${slActualPrice.toFixed(2)}`;
                      } else {
                        slDisplay = slValueType === 1 ? `${slValue.toFixed(2)}%` : `${slValue.toFixed(2)} pts`;
                      }
                    }
                    summaryLines.push(`If ${basisLabel} falls to ${slDisplay}, the strategy will exit.`);
                  }
                }

                // Target
                if (formData.takeProfitAbsolute !== null && formData.takeProfitAbsolute !== undefined && formData.takeProfitAbsolute !== '') {
                  const tpValue = parseFloat(formData.takeProfitAbsolute);
                  let tpText = '';
                  if (formData?.sltpType === "PNL" || istype === "broker") {
                    if (tpValueType === 0) {
                      tpText = `₹${Math.abs(tpValue).toFixed(2)}`;
                    } else {
                      // For Pts, show actual price
                      if (tpActualPrice !== null) {
                        tpText = `₹${Math.abs(tpActualPrice).toFixed(2)}`;
                      } else {
                        tpText = `${Math.abs(tpValue).toFixed(2)} pts`;
                      }
                    }
                    summaryLines.push(`If ${basisLabel} rises to ${tpText}, the strategy will exit with profit.`);
                  } else {
                    let tpDisplay = '';
                    if (tpValueType === 0) {
                      tpDisplay = `₹${tpValue.toFixed(2)}`;
                    } else if (tpValueType === 1 || tpValueType === 2) {
                      // For % and Pts, show actual price
                      if (tpActualPrice !== null) {
                        tpDisplay = `₹${tpActualPrice.toFixed(2)}`;
                      } else {
                        tpDisplay = tpValueType === 1 ? `${tpValue.toFixed(2)}%` : `${tpValue.toFixed(2)} pts`;
                      }
                    }
                    summaryLines.push(`If ${basisLabel} rises to ${tpDisplay}, the strategy will exit with profit.`);
                  }
                }

                // Stoploss Trailing
                if ((formData.trailReferenceAbsolute !== null && formData.trailReferenceAbsolute !== undefined && formData.trailReferenceAbsolute !== '') &&
                  (formData.trailStepAbsolute !== null && formData.trailStepAbsolute !== undefined && formData.trailStepAbsolute !== '')) {
                  const refValue = parseFloat(formData.trailReferenceAbsolute);
                  const stepValue = parseFloat(formData.trailStepAbsolute);
                  let refText = '';
                  let stepText = '';

                  if (formData?.sltpType === "PNL" || istype === "broker") {
                    refText = `₹${refValue.toFixed(2)}`;
                    stepText = `₹${stepValue.toFixed(2)}`;
                  } else {
                    if (trailValueType === 1) {
                      // For %, show actual price if available
                      if (trailRefActualPrice !== null && trailStepActualPrice !== null) {
                        refText = `₹${trailRefActualPrice.toFixed(2)}`;
                        stepText = `₹${trailStepActualPrice.toFixed(2)}`;
                      } else {
                        refText = `${refValue.toFixed(2)}%`;
                        stepText = `${stepValue.toFixed(2)}%`;
                      }
                    } else {
                      refText = `₹${refValue.toFixed(2)}`;
                      stepText = `₹${stepValue.toFixed(2)}`;
                    }
                  }
                  summaryLines.push(`For every ${refText} increase in profit, SL will move up by ${stepText}.`);
                }

                // Profit Locking
                if ((formData[profitKeys.profitAt] !== null && formData[profitKeys.profitAt] !== undefined && formData[profitKeys.profitAt] !== '') &&
                  (formData[profitKeys.profitSl] !== null && formData[profitKeys.profitSl] !== undefined && formData[profitKeys.profitSl] !== '')) {
                  const atValue = parseFloat(formData[profitKeys.profitAt]);
                  const slValue = parseFloat(formData[profitKeys.profitSl]);
                  summaryLines.push(`When profit reaches ₹${atValue.toFixed(2)}, at least ₹${slValue.toFixed(2)} will be protected.`);
                }

                // Profit Trailing
                if ((formData[profitKeys.trailRef] !== null && formData[profitKeys.trailRef] !== undefined && formData[profitKeys.trailRef] !== '') &&
                  (formData[profitKeys.trailStep] !== null && formData[profitKeys.trailStep] !== undefined && formData[profitKeys.trailStep] !== '')) {
                  const refValue = parseFloat(formData[profitKeys.trailRef]);
                  const stepValue = parseFloat(formData[profitKeys.trailStep]);
                  summaryLines.push(`Each time profit increases by ₹${refValue.toFixed(2)}, locked profit will rise by ₹${stepValue.toFixed(2)}.`);
                }

                if (summaryLines.length === 0) {
                  return <div style={{ color: '#6c757d', fontStyle: 'italic' }}>No risk settings configured</div>;
                }

                return summaryLines.map((line, index) => (
                  <div key={index} style={{ marginBottom: index < summaryLines.length - 1 ? '8px' : '0' }}>
                    {line}
                  </div>
                ));
              })()}
            </div>
          </div>
          {errorMessages.general && (
            <div className="alert alert-danger mt-3 mb-0 py-2 px-3" style={{ fontSize: '12px', borderRadius: '4px' }}>
              {errorMessages.general}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleReset} variant="outline-primary">Reset</Button>
          <Button disabled={!!errorMessages.stopLoss || !!errorMessages.target || !!errorMessages.trailSL || !!errorMessages.profitLock || !!errorMessages.profitLockTrail || !!errorMessages.general} onClick={() => { if (clickActionSave()) setShow(false) }}>Save</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SLTPModal;